import { UPDATE_PROPOSAL_ACTION } from 'actions/types';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import restFactory from 'v2/utils/restFactory';

type RejectProposalProps = {
  id: number;
  proposalRejectionOptionID?: null | number;
  reason: string;
};

function rejectProposal({
  id,
  reason,
  proposalRejectionOptionID,
}: RejectProposalProps) {
  return restFactory.put(`/proposals/${id}`, {
    action: 'negative',
    response: reason,
    proposal_rejection_option: proposalRejectionOptionID,
  });
}

export function useRejectProposal() {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: rejectProposal,
    onSuccess: (data) => {
      dispatch({ type: UPDATE_PROPOSAL_ACTION, payload: data });
    },
    onError: () => {
      toast.error('Failed to reject proposal.');
    },
  });
}
